module.exports = __webpack_public_path__ + "assets/whatsapp1.9892a9e1.svg";